import 'src/i18n/config';

import React, { useEffect, useState } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { RouterProvider } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LicenseInfo } from '@mui/x-license';
import dayjs from 'dayjs';

import { MotionLazyContainer } from './components/animate';
import { setRootStoreSingleton } from './models/root-store/root-store-singleton';
import { RootStore, RootStoreProvider, setupRootStore } from './models';
import router from './routes';
import ThemeProvider from './theme';

function App() {
  const [rootStore, setRootStore] = useState<RootStore | undefined>(undefined);
  const { i18n } = useTranslation();

  useEffect(() => {
    // setup root store
    setupRootStore().then((store) => {
      setRootStore(store);
      setRootStoreSingleton(store);
      // 로그인 확인만 한다. 로그인 전이거나 풀려 있으면 안내 없이 로그인 화면으로 간다
      if (store.authStore.getAccessToken()) {
        store.authStore.getUserProfile(true);
      } else {
        store.authStore.setProp('isInitialized', true);
      }
    });

    // mui pro license
    LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_PRO_LICENSE_KEY ?? '');
  }, []);

  // 언어 변경 시 locale 변경
  useEffect(() => {
    dayjs.locale(i18n.language);
  }, [i18n.language]);

  if (!rootStore) {
    return null;
  }

  return (
    <RootStoreProvider value={rootStore}>
      <HelmetProvider>
        <ThemeProvider>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <MotionLazyContainer>
              <RouterProvider
                router={router}
                future={{
                  v7_startTransition: true,
                }}
              />
            </MotionLazyContainer>
          </LocalizationProvider>
        </ThemeProvider>
      </HelmetProvider>
    </RootStoreProvider>
  );
}

export default App;
